/* eslint-disable import/prefer-default-export */
import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/catalogos/marcas-de-motocicletas/';

/**
 * GET Marcas de Motocicletas
 * @returns {Promise<object[]>}
 */
export const getMarcasDeMotocicletas = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * POST Marca de Motocicleta
 * @param {object} values
 * @returns {Promise<object[]>}
 */
export const postMarcasDeMotocicletas = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * PATCH Marca de Motocicleta
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchMarcaDeMotocicleta = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Marca de Motocicleta
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteMarcaDeMotocicleta = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
